var _hmt = _hmt || [];
(function () {
  let str = window.location.href;
  if (str.indexOf('/i/') !== -1 || str.indexOf('/i/') !== -1) {
    
  } else {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?5d0d28b17c6bfea1c00e337b166ffec2";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  }
})();